import React from "react";
import "../Headers/Header.css"

const Header = ({ headerTitle, headerContent }) => {
  return (
    <div>
      <div className="header">
        <div className="bg-layer">
          <div className="container">
            <div className="title">
              <h2>{headerTitle}</h2>
              <p>
                {headerContent}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
